export default __webpack_public_path__ + "static/adam-sig-83e46b55f264caff448629bf526c1181.png";